import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "AddPostView" }

import { onMounted, ref } from "vue";
import MdEditor from "@/components/MdEditor.vue";
import message from "@arco-design/web-vue/es/message";
import { PostAddRequest, PostControllerService } from "../../generated";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddPostView',
  setup(__props) {

const post = ref({
  title: "",
  content: "",
  tag: ["简单"] as string[],
} as PostAddRequest);

const route = useRoute();

const loadData = async () => {
  const id = route.query.id;
  if (!id) {
    return;
  }
  const res: any = await PostControllerService.getPostVoByIdUsingGet(id as any);
  if (res.code === 0) {
    post.value = res.data;
    if (!post.value.tag) {
      post.value.tag = ["简单"];
    } else {
      post.value.tag = JSON.parse(res.data.tag);
    }
  } else {
    message.error("加载失败！ " + res.message);
  }
};
onMounted(() => {
  loadData();
});

const onContentChange = (v: string) => {
  post.value.content = v;
};

const handleSubmit = async () => {
  const res = await PostControllerService.addPostUsingPost(post.value);
  if (res.code === 0) {
    message.success("创建帖子成功！");
  } else {
    message.error("创建帖子失败 " + res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", null, "发布帖子", -1)),
    _createVNode(_component_a_form, {
      model: post.value,
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "title",
          label: "标题"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: post.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((post.value.title) = $event)),
              class: "formItem",
              placeholder: "请输入标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "content",
          label: "帖子正文"
        }, {
          default: _withCtx(() => [
            _createVNode(MdEditor, {
              "handle-change": onContentChange,
              value: post.value.content,
              class: "formItem"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "tag",
          label: "标签"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_tag, {
              modelValue: post.value.tag,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((post.value.tag) = $event)),
              "allow-clear": "",
              class: "formItem",
              placeholder: "请输入标签"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          "html-type": "submit",
          style: {"width":"20%"},
          type: "primary"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("提交 ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})